"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const material_1 = require("@mui/material");
const ListSubheader_1 = tslib_1.__importDefault(require("@mui/material/ListSubheader"));
const MneListSubheader = (0, material_1.styled)(ListSubheader_1.default)(({ theme }) => ({
    color: theme.palette.text.secondary,
    backgroundColor: "unset",
    lineHeight: "32px",
    paddingLeft: theme.spacing(1),
}));
exports.default = MneListSubheader;
